import axios from '@/axios';

const RESOURCE_NAME = '/admin/needs';

export default {
    getList(data) {
        return axios.post(`${RESOURCE_NAME}/get-list`, data)
    },

    getFoundStartups(id, data) {
        return axios.post(`${RESOURCE_NAME}/get-found-startups?id=${id}`, data)
    },

    setPublicStatus(ids, status) {
        return axios.post(`${RESOURCE_NAME}/set-public-status`, {ids: ids, status: status});
    },
}
